module.exports = __webpack_public_path__ + "img/CHECHEN.3984eb50.png";